var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 0.25C13.8467 0.25 14.419 0.487053 14.841 0.90901C15.2629 1.33097 15.5 1.90326 15.5 2.5V10C15.5 10.5967 15.2629 11.169 14.841 11.591C14.419 12.0129 13.8467 12.25 13.25 12.25H4.49975L2 14.125C1.382 14.5885 0.5 14.1475 0.5 13.375V2.5C0.5 1.90326 0.737053 1.33097 1.15901 0.90901C1.58097 0.487053 2.15326 0.25 2.75 0.25H13.25ZM7.25 7H5C4.80109 7 4.61032 7.07902 4.46967 7.21967C4.32902 7.36032 4.25 7.55109 4.25 7.75C4.25 7.94891 4.32902 8.13968 4.46967 8.28033C4.61032 8.42098 4.80109 8.5 5 8.5H7.25C7.44891 8.5 7.63968 8.42098 7.78033 8.28033C7.92098 8.13968 8 7.94891 8 7.75C8 7.55109 7.92098 7.36032 7.78033 7.21967C7.63968 7.07902 7.44891 7 7.25 7ZM11 4H5C4.80884 4.00021 4.62498 4.07341 4.48597 4.20464C4.34697 4.33586 4.26332 4.51521 4.25212 4.70605C4.24092 4.89688 4.30301 5.08478 4.4257 5.23137C4.54839 5.37796 4.72243 5.47217 4.91225 5.49475L5 5.5H11C11.1912 5.49979 11.375 5.42659 11.514 5.29536C11.653 5.16414 11.7367 4.98479 11.7479 4.79395C11.7591 4.60312 11.697 4.41522 11.5743 4.26863C11.4516 4.12204 11.2776 4.02783 11.0878 4.00525L11 4Z",
    fill: "#FB8041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.46a07c973a0a7239c459ac83f974a805.svg";
export { ForwardRef as ReactComponent };